<template>
<div id="cgg_mem">
	<header>
		<dl>
			<dt>
				<img style="width:95px;height: 95px;border-radius: 50%" :src="fans.headimgurl" />
				<span class="jb"><img src="/static/jb.png"></span>
			</dt>
			<dd>
				<h3>{{user.sname}}</h3>
				<span>卡号 8{{user.smobile}}</span>
			</dd>
		</dl>
		<ul>
			<a href="javascript:;" @click="point">
				<li><h3>{{user.jf}}</h3><span>积分余额</span></li>
			</a>
			<li style="width:4%;text-align: center;margin-left: 0.5rem;font-size: 0.6rem;color:#ccc"><i class="fr line"></i></li>
			<a href="javascript:;">
				<li style="float:right"><h3>{{user.emrlt_sname}}</h3><span>会员等级</span></li>
			</a>
		</ul>
		<a href="javascript:;" @click="logout">
			<span class="sz"><img src="/static/sz.png" /></span>
		</a>
	</header>
	<div id="mem_content">
		<!-- aside class="order">
			<dl>
				<dt><img src="/static/line3.png"></dt>
				<dd>我的订单</dd>
			</dl>
			<a href="/index.php/Home/Member/my_order.html">
				<dl>
					<dd>全部订单</dd>
					<dt><img src="/static/rarrow.png"></dt>
				</dl>
			</a>
		</asid -->
		<aside class="list">
			<a href="javascript:;" @click="jcjt">
				<dl><dt><img src="/static/fk.png" /></dt><dd>寄存订单</dd></dl>
			</a>
			<a href="javascript:;" @click="stock">
				<dl><dt><img src="/static/wl.png" /></dt><dd>寄存库存</dd></dl>
			</a>
			<a href="javascript:;" @click="df">
				<dl><dt><img src="/static/sh.png" /></dt><dd>代发订单</dd></dl>
			</a>
			<a href="javascript:;" @click="giftorder">
				<dl><dt><img src="/static/pj.png" /></dt><dd>礼品卡订单</dd></dl>
			</a>
		</aside>
		<div class="hr" style="height: 20px;"></div>
		<aside class="ullist">
			<a @click="giftbirth">
				<dl><dt><img src="/static/collect.png" /></dt><dd>我的生日券</dd></dl>
			</a>
			<a @click="giftcamp">
				<dl><dt><img src="/static/collect.png" /></dt><dd>我的定向券</dd></dl>
			</a>
			<a @click="inoutcheckcode">
				<dl><dt><img src="/static/code.png" /></dt><dd>寄存/寄提验证码</dd></dl>
			</a>
			<a href="tel:4000365928" v-if="site == 'BjXz'">
				<dl><dt><img src="/static/lj.png" /></dt><dd>北京晓增商贸有限公司</dd></dl>
			</a>
			<a href="tel:4000365928" v-if="site == 'BjXz'">
				<dl><dt><img src="/static/lx.png" /></dt><dd>联系我们4000365928</dd></dl>
			</a>
			<a href="tel:4006990605" v-if="site == 'ShSg'">
				<dl><dt><img src="/static/lj.png" /></dt><dd>上海参工实业有限公司</dd></dl>
			</a>
			<a href="tel:4006990605" v-if="site == 'ShSg'">
				<dl><dt><img src="/static/lx.png" /></dt><dd>联系我们4006990605</dd></dl>
			</a>
			<div class="hr"></div>
		</aside>
</div>
</div>

</template>

<script>
import {
  Current,
  Auth_Logout,
  IsWxBind,
  OrderInOut_CheckCode
} from "@/api/api.js"

export default {
  data () {
    return {
		user:{
			sname:'',
			emrlt_sname:'',
			jf:0.00,
			smobile:''
		},
		fans:{
			headimgurl:'/static/icon.jpg',
			nickname:''
		},
		site:""
    }
  },
  methods:{
	  jcjt:function(){
		  let that = this;
		  that.$router.push('jcjt');
	  },
	  df:function(){
		  let that = this;
		  that.$router.push('df');
	  },
	  point:function(){
		  let that = this;
		  that.$router.push('point');
	  },
	  stock:function(){
		  let that = this;
		  that.$router.push('stock');
	  },
	  giftorder:function(){
		  let that = this;
		  that.$router.push('giftorder');
	  },
	  giftbirth:function(){
		  let that = this;
		  that.$router.push('giftbirth');
	  },
	  inoutcheckcode:function(){
		  let that = this;
		  OrderInOut_CheckCode({},function(res){
			  that.$message.success(res.message);
		  })
	  },
	  giftcamp:function(){
		  let that = this;
		  that.$router.push('giftcamp');
	  },
	  nodata:function(){
		alert('暂无内容！');
	  },
      logout:function(){
          let that = this;
			this.$confirm({
				title: '退出',
				okText: '确认退出',
				okType: 'danger',
				cancelText: '取消',
				content: h => <div style="color:red;">是否确认退出系统？</div>,
				onOk() {
			  		Auth_Logout({},function(res){ location.href = '/'; })
				},
				onCancel() {
					console.log('Cancel');
				},
				class: 'test',
			});
      }
  },
  created:function(){
	  let that = this;
	  if(location.hostname == 'hy.xiaoqinhaishen.com')
		that.site = 'BjXz';
	  else if(location.hostname == 'hy.shengongshiye.com')
		that.site = 'ShSg';
	  Current({},function(res){
		that.user = res.model;
		IsWxBind({},function(res){
			if(res.extand.fans)
				that.fans = res.extand.fans;
		});
	  })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/home.vue